import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuxiliarService } from './../../auxiliar.service';

@Injectable({
  providedIn: 'root'
})
export class ScalesService {
  server: string = '';
  serverApi: string = '';

  constructor(private httpClient: HttpClient, private auxiliarService: AuxiliarService) {
    this.server = this.auxiliarService.getServidor() + "/api/scales";
    this.serverApi = this.auxiliarService.getServidor() + "/api";
  }

  getScales(active: string = 'true') {
    return this.httpClient.get(this.server + '/' + active);
  }

  getPublicScales() {
    return this.httpClient.get(this.auxiliarService.getServidor() + '/api/scales/public');
  }

  getAllowedScales(active: string = 'true') {
    return this.httpClient.get(this.serverApi + '/scales/allowed/' + active);
  }

  newScale(
    name: string,
    description: string,
    active: string,
    defaultIdCamion: number | null = null,
    defaultIdMaterial: number | null = null,
    crop?: { x: number; y: number; w: number; h: number } | null,
  ) {
    const formData = new FormData();
    formData.append('name', name);
    formData.append('description', description);
    formData.append('active', active);
    formData.append('default_id_camion', defaultIdCamion != null ? String(defaultIdCamion) : '');
    formData.append('default_id_material', defaultIdMaterial != null ? String(defaultIdMaterial) : '');
    if (crop) {
      formData.append('crop_x', String(crop.x));
      formData.append('crop_y', String(crop.y));
      formData.append('crop_w', String(crop.w));
      formData.append('crop_h', String(crop.h));
    }
    return this.httpClient.post(this.server, formData);
  }

  editScale(
    idScale: number,
    name: string,
    description: string,
    active: string,
    defaultIdCamion: number | null = null,
    defaultIdMaterial: number | null = null,
    crop?: { x: number; y: number; w: number; h: number } | null,
  ) {
    const formData = new FormData();
    formData.append('idScale', idScale.toString());
    formData.append('name', name);
    formData.append('description', description);
    formData.append('active', active);
    formData.append('default_id_camion', defaultIdCamion != null ? String(defaultIdCamion) : '');
    formData.append('default_id_material', defaultIdMaterial != null ? String(defaultIdMaterial) : '');
    if (crop) {
      formData.append('crop_x', String(crop.x));
      formData.append('crop_y', String(crop.y));
      formData.append('crop_w', String(crop.w));
      formData.append('crop_h', String(crop.h));
    }
    return this.httpClient.post(this.server + '/update', formData);
  }

  getCropSample(idScale: number) {
    return this.httpClient.get<{ status: string; image: string | null }>(this.server + '/crop-sample/' + idScale);
  }

  uploadCropSample(idScale: number, dataUrl: string) {
    const formData = new FormData();
    formData.append('image', dataUrl);
    return this.httpClient.post<{ status: string; filename?: string }>(this.server + '/crop-sample/' + idScale, formData);
  }

  getCropImageByName(imageName: string) {
    return this.httpClient.get<{ status: string; image: string }>(
      this.server + '/crop-image/' + encodeURIComponent(imageName)
    );
  }

  deleteScale(idScale: number) {
    return this.httpClient.delete(this.server + '/' + idScale);
  }
}
